import { UserOutlined } from "@ant-design/icons";
import { Avatar, Flex, Statistic, Typography } from "antd";
import PubSub from "pubsub-js";
import { useEffect, useState } from "react";
import { useToken } from "../../hooks/useToken";
import { TProfile } from "../../models/users.model";
import { useIntegrations } from "../../providers/IntegrationsProvider";
import { getMediaFile } from "../../services/media.service";
import { getUserProfile } from "../../services/users.service";
const { Text } = Typography;

export function DashboardHeader() {
  const { token, screens } = useToken();
  const [profile, setProfile] = useState<TProfile>();
  const [avatarUrl, setAvatarUrl] = useState<string>();
  const { integrations } = useIntegrations();

  // const [reviewsCount, setReviewsCount] = useState<number>();

  useEffect(() => {
    getUserProfile({
      onSuccess: setProfile,
    });

    const subscribe = PubSub.subscribe("profileUpdate", (_, data) => {
      setProfile(data);
    });

    return () => {
      PubSub.unsubscribe(subscribe);
    };
  }, []);

  useEffect(() => {
    getUserProfile({
      onSuccess: (data) => {
        if (data.avatar) {
          getMediaFile({
            mediaId: data.avatar,
            onSuccess: (data) => {
              setAvatarUrl(URL.createObjectURL(data));
            },
          });
        }
      },
    });
  }, []);

  // useEffect(() => {
  //   const loadReviews = () => {
  //     getPosts({
  //       type: EPostType.REVIEW,
  //       onSuccess: (data) => {
  //         setReviewsCount(data.content.length);
  //       },
  //     });
  //   };

  //   const intervalId = setInterval(() => loadReviews(), 5 * 60 * 1000);
  //   loadReviews();

  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, []);

  // useEffect(() => {
  //   function onPostCreated(post: TPost) {
  //     if (post.type == EPostType.REVIEW && post.status == EPostStatus.PUBLISH) {
  //       setReviewsCount((reviewsCount || 0) + 1);
  //     }
  //   }

  //   socket.on("postCreated", onPostCreated);

  //   return () => {
  //     socket.off("postCreated", onPostCreated);
  //   };
  // }, [socket, reviewsCount]);

  const currentHour = new Date().getHours();
  let greetings = "";

  // Small interaction with user

  if (currentHour >= 0 && currentHour < 6) {
    greetings = "It's too late, ";
  } else if (currentHour >= 6 && currentHour < 12) {
    greetings = "Good morning, ";
  } else if (currentHour >= 12 && currentHour < 18) {
    greetings = "Good afternoon, ";
  } else if (currentHour >= 18 && currentHour < 24) {
    greetings = "Good evening, ";
  }

  return (
    <>
      <Flex
        align="center"
        justify="space-between"
        style={{
          padding: token.paddingLG,
          borderBottom: `1px solid ${token.colorSplit}`,
        }}
      >
        {screens.xl && (
          <Flex align="center">
            <Avatar
              shape="circle"
              size={64}
              icon={<UserOutlined />}
              src={avatarUrl}
              style={{
                marginRight: token.marginLG,
              }}
            />

            <Flex style={{ flexDirection: "column" }}>
              <Text
                style={{
                  fontSize: token.fontSizeHeading3,
                  color: token.colorText,
                }}
              >
                {greetings} {profile?.name}
              </Text>
              {/* <Text
                style={{
                  fontSize: token.fontSize,
                  color: token.colorTextSecondary,
                }}
              >
                A recently retired lawyer with a deep passion for preserving
                family history and traditions.
              </Text> */}
            </Flex>
          </Flex>
        )}

        <Flex
          align="center"
          style={{
            width: !screens.xl ? "100%" : "auto",
          }}
          justify={screens.xl ? "flex-end" : "space-between"}
        >
          {/* <Statistic
            title="Events to review"
            value={reviewsCount}
            loading={reviewsCount === undefined}
            valueStyle={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          /> */}
          {/* <Divider
            type="vertical"
            style={{ height: "58px", margin: `0 ${token.marginXXL}px` }}
          /> */}
          {/* <Statistic
            title="Social Lifetime"
            loading={!profile}
            value={formatRemainingTime(profile?.timespent || 0)}
            valueStyle={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          /> */}
          {/* <Divider
            type="vertical"
            style={{ height: "58px", margin: `0 ${token.marginXXL}px` }}
          /> */}
          <Statistic
            title="Connections"
            value={integrations.length}
            valueStyle={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          />
        </Flex>
      </Flex>
    </>
  );
}
